import React from "react";

export default function CustomSlider({ text, description, image }) {
  return (
    <section className="slider">
      <img src={image} alt={description} className="slider__image" />
      <div className="slider__description">
        {text.map((block, index) => {
          if (block.type === "paragraph") {
            return (
              <p key={index} className="history__photo_text">
                {block.content}
              </p>
            );
          }
          if (block.type === "list") {
            return block.items.map((item, i) => (
              <li key={`li-${i}`} className="history__photo_text">
                {item}
              </li>
            ));
          }
          return null;
        })}
      </div>
    </section>
  );
}
